export default "__VITE_ASSET__CwdnhP_j__"